module.exports = __webpack_public_path__ + "ebf46660271b0c6f107cd1de6c628660.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art-1920.jpg
// module id = 438
// module chunks = 0